window.addEventListener("load", initSellingPlanSelectorContainers);

function initSellingPlanSelectorContainers() {
  const sellingPlanSelectors = document.querySelectorAll(
    "[data-selling_plan_selector]"
  );
  if (!sellingPlanSelectors || !sellingPlanSelectors.length) return;
  sellingPlanSelectors.forEach(initSellingPlanSelector);
}

function initSellingPlanSelector(selector) {
  const sellingPlanGroups = selector.querySelectorAll(
    "[data-selling_plan_group]"
  );
  if (!sellingPlanGroups || !sellingPlanGroups.length) return;
  const sellingPlanAllocations = getSellingPlanAllocationsByVariant(selector);
  sellingPlanGroups.forEach((group) =>
    initSellingPlanGroup(selector, group, sellingPlanAllocations)
  );
}

function initSellingPlanGroup(selector, group, sellingPlanAllocations) {
  const groupId = group.dataset.selling_plan_group;
  const groupSellingPlans =
    groupId != "null" ? getSellingPlansByGroup(groupId, selector) : [];
  group.addEventListener("click", function () {
    if (group.dataset.hasOwnProperty("selected")) return;
    setSelectedGroup(group, selector);
    const selectedSellingPlanAllocation = getSelectedSellingPlanAllocation(
      groupId,
      groupSellingPlans,
      sellingPlanAllocations,
      selector
    );
    updateSelectedSellingPlan(
      selector,
      selectedSellingPlanAllocation.selling_plan_id
    );
    if (selector.dataset.type === "add_on") return;
    updateProductUrl(
      selectedSellingPlanAllocation.variant_id,
      selectedSellingPlanAllocation.selling_plan_id
    );
  });
  const groupOptions = selector.querySelectorAll(
    `[data-group_options='${groupId}']`
  );
  groupOptions.forEach((option) =>
    initSellingPlanGroupOptions(
      selector,
      option,
      groupSellingPlans,
      sellingPlanAllocations
    )
  );

  if (selector.dataset.type === "add_on" || groupId === "null") return;
  document.body.addEventListener("ProductVariantUpdate", function (event) {
    if (event.detail === undefined) return;
    const selectedSellingPlanAllocation = getSelectedSellingPlanAllocation(
      groupId,
      groupSellingPlans,
      sellingPlanAllocations,
      selector
    );
    displaySellingPlanOutputByGroup(
      selector,
      groupId,
      selectedSellingPlanAllocation
    );
    //console.log('From product-selling-plans.js', selectedSellingPlanAllocation);
  });
}

function setSelectedGroup(group, selector) {
  const current = selector.querySelector(
    "[data-selling_plan_group][data-selected]"
  );
  if (current) toggleGroupContent(current.dataset.selling_plan_group, selector);
  current.removeAttribute("data-selected");
  group.dataset.selected = true;
  toggleGroupContent(group.dataset.selling_plan_group, selector);
}

function toggleGroupContent(id, selector) {
  const groupContent = selector.querySelector(`[data-group_content='${id}']`);
  if (!groupContent) return;
  const hiddenClass = groupContent.dataset.toggle_class;
  groupContent.classList.toggle(hiddenClass);
}

function initSellingPlanGroupOptions(
  selector,
  option,
  sellingPlans,
  sellingPlanAllocations
) {
  //const sellingPlanUpdateEvent = new CustomEvent('ProductSellingPlanUpdate', { detail: { group_id: option.dataset.group_options } });
  const optionValues = option.querySelectorAll("[data-group_option_value]");
  optionValues.forEach((value) => {
    value.addEventListener("click", function () {
      if (value.dataset.hasOwnProperty("selected")) return false;
      const optionValue = setSelectedValue(value, option);
      if (!optionValue) return;
      option.dataset.options_value = optionValue;
      const selectedSellingPlanAllocation = getSelectedSellingPlanAllocation(
        option.dataset.group_options,
        sellingPlans,
        sellingPlanAllocations,
        selector
      );
      updateSelectedSellingPlan(
        selector,
        selectedSellingPlanAllocation.selling_plan_id
      );
      displaySellingPlanOutputByGroupOptions(
        selector,
        option.dataset.group_options,
        sellingPlans,
        sellingPlanAllocations
      );
      displaySellingPlanOutputByGroup(
        selector,
        option.dataset.group_options,
        selectedSellingPlanAllocation
      );
      console.log("displayed outputs by group, from group options");
      if (selector.dataset.type === "add_on") return;
      updateProductUrl(
        selectedSellingPlanAllocation.variant_id,
        selectedSellingPlanAllocation.selling_plan_id
      );
    });

    document.body.addEventListener("ProductVariantUpdate", function (event) {
      if (event.detail === undefined) return;
      displaySellingPlanOutputByGroupOptions(
        selector,
        option.dataset.group_options,
        sellingPlans,
        sellingPlanAllocations
      );
    });
  });
}

function setSelectedValue(value, option) {
  const current = option.querySelector(
    "[data-group_option_value][data-selected]"
  );
  current.removeAttribute("data-selected");
  value.dataset.selected = true;
  return value.dataset.group_option_value;
}

function getSellingPlanAllocationsByVariant(selector) {
  const sellingPlanAllocations = {};
  const sellingPlanAllocationsList = selector.querySelectorAll(
    "[data-selling_plan_allocations]"
  );
  if (!sellingPlanAllocationsList || !sellingPlanAllocationsList.length)
    return sellingPlanAllocations;
  sellingPlanAllocationsList.forEach((sellingPlanAllocationsItem) => {
    const sellingPlanList = sellingPlanAllocationsItem.querySelectorAll(
      "[data-selling_plan]"
    );
    const sellingPlans = [];
    //sellingPlanList.forEach((item) => sellingPlans.push({ selling_plan_id: item.dataset.selling_plan }));
    sellingPlanList.forEach((item) =>
      sellingPlans.push({
        selling_plan_id: item.dataset.selling_plan,
        price: item.dataset.price,
        compare_at_price: item.dataset.compare_at_price,
        price_adjustment: item.dataset.hasOwnProperty("price_adjustment")
          ? item.dataset.price_adjustment
          : null,
        variant_id: sellingPlanAllocationsItem.dataset.selling_plan_allocations,
      })
    );
    sellingPlanAllocations[
      sellingPlanAllocationsItem.dataset.selling_plan_allocations
    ] = sellingPlans;
  });

  sellingPlanAllocationsList.forEach((sellingPlanAllocationsItem) => {
    sellingPlanAllocationsItem.parentElement.removeChild(
      sellingPlanAllocationsItem
    );
  });
  return sellingPlanAllocations;
}

function getSellingPlansByGroup(groupId, selector) {
  const sellingPlans = [];
  const sellingPlansList = selector.querySelector(
    `[data-group_selling_plans='${groupId}']`
  );
  if (!sellingPlansList) return sellingPlans;
  const sellingPlanItems = sellingPlansList.querySelectorAll(
    "[data-selling_plan]"
  );
  sellingPlanItems.forEach((item) => {
    const optionList = item.querySelectorAll("[data-selling_plan_option]");
    const options = [];
    optionList.forEach((option) =>
      options.push({
        position: option.dataset.position,
        value: option.dataset.value,
      })
    );
    const sellingPlanInfo = {
      id: item.dataset.selling_plan,
      options: options,
    };
    sellingPlans.push(sellingPlanInfo);
  });
  sellingPlansList.parentElement.removeChild(sellingPlansList);
  return sellingPlans;
}

function getSelectedSellingPlanGroupOptions(groupId, selector) {
  const selectedOptions = [];
  const sellingPlanGroupOptions = selector.querySelectorAll(
    `[data-group_options='${groupId}']`
  );
  sellingPlanGroupOptions.forEach((option) => {
    const selectedOption = {
      position: option.dataset.options_position,
      value: option.dataset.options_value,
    };
    selectedOptions.push(selectedOption);
  });
  return selectedOptions;
}

function getSelectedSellingPlan(options, sellingPlans) {
  const selectedSellingPlan = sellingPlans.find((sellingPlan) => {
    const optionsMatched = options.every((option) => {
      const matchedOption = sellingPlan.options.find(
        (planOption) =>
          planOption.position == option.position &&
          planOption.value == option.value
      );
      return matchedOption ? true : false;
    });
    return optionsMatched;
  });
  return selectedSellingPlan;
}

function getSelectedSellingPlanAllocation(
  sellingPlanGroup,
  sellingPlans,
  sellingPlanAllocations,
  selector
) {
  const productForm = document.querySelector(
    `form[data-product_form='${selector.dataset.selling_plan_selector}']`
  );
  //const sellingPlanInput = productForm.querySelector("input[name='selling_plan']");
  const variantInput = productForm.querySelector("input[name='id']");

  const selectedOptions = getSelectedSellingPlanGroupOptions(
    sellingPlanGroup,
    selector
  );
  const selectedSellingPlan = getSelectedSellingPlan(
    selectedOptions,
    sellingPlans
  );
  const selectedSellingPlanAllocation =
    typeof selectedSellingPlan === "undefined"
      ? { selling_plan_id: "", variant_id: variantInput.value }
      : sellingPlanAllocations[variantInput.value].find(
          (sellingPlanAllocation) =>
            sellingPlanAllocation.selling_plan_id == selectedSellingPlan.id
        );
  if (typeof selectedSellingPlanAllocation === "undefined")
    return selectedSellingPlanAllocation;
  //if (sellingPlanInput) sellingPlanInput.value = selectedSellingPlanAllocation.selling_plan_id;

  return selectedSellingPlanAllocation;
}

function updateSelectedSellingPlan(selector, sellingPlan) {
  const productForm = document.querySelector(
    `form[data-product_form='${selector.dataset.selling_plan_selector}']`
  );
  const sellingPlanInput = productForm.querySelector(
    "input[name='selling_plan']"
  );
  sellingPlanInput.value =
    typeof sellingPlan === "undefined" ? "" : sellingPlan;
}

function displaySellingPlanOutputByGroup(
  selector,
  group,
  sellingPlanAllocation
) {
  const sellingPlanOutputs = selector.querySelectorAll(
    `[data-selling_plan_output][data-group_id='${group}']`
  );
  sellingPlanOutputs.forEach((output) => {
    output.textContent =
      sellingPlanAllocation[output.dataset.selling_plan_output];
  });
}

function displaySellingPlanOutputByGroupOptions(
  selector,
  group,
  sellingPlans,
  sellingPlanAllocations
) {
  const productForm = document.querySelector(
    `form[data-product_form='${selector.dataset.selling_plan_selector}']`
  );
  const variantInput = productForm.querySelector("input[name='id']");
  const groupOptions = selector.querySelectorAll(
    `[data-group_options='${group}']`
  );
  groupOptions.forEach((option) => {
    const optionValues = option.querySelectorAll("[data-group_option_value]");
    optionValues.forEach((value) => {
      const selectedOptions = getSelectedSellingPlanGroupOptions(
        group,
        selector
      );
      const currentOptions = selectedOptions.map((selectedOption) =>
        selectedOption.position === value.dataset.group_option_position
          ? {
              position: selectedOption.position,
              value: value.dataset.group_option_value,
            }
          : selectedOption
      );
      const defaultSellingPlan = getSelectedSellingPlan(
        currentOptions,
        sellingPlans
      );
      const defaultSellingPlanAllocation =
        typeof defaultSellingPlan === "undefined"
          ? { selling_plan_id: "", variant_id: variantInput.value }
          : sellingPlanAllocations[variantInput.value].find(
              (sellingPlanAllocation) =>
                sellingPlanAllocation.selling_plan_id == defaultSellingPlan.id
            );
      //console.log(defaultSellingPlanAllocation);
      const outputs = option.querySelectorAll(
        `[data-selling_plan_option_output][data-option_value='${value.dataset.group_option_value}']`
      );
      if (!outputs || !outputs.length) return;
      outputs.forEach((output) => {
        output.textContent =
          defaultSellingPlanAllocation[
            output.dataset.selling_plan_option_output
          ];
      });
    });
  });
}
document.addEventListener("DOMContentLoaded", function () {
  const subscribeInput = document.querySelector(
    'input[value="be5676770f7a2a402f39044871b9ae3b86c22e15"]'
  ); // Subscribe and Save input
  const oneTimeInput = document.querySelector('input[value="once"]'); // One-time Purchase input
  const divToHide = document.querySelector(".cc-toggle-subscription-info"); // Div to hide
  const subscribeSaveDiv = document.querySelector(".cc-subscribe-and-save"); // Toggle infobox
  function toggleDivVisibility() {
    if (subscribeInput.checked) {
      divToHide.style.display = "flex"; // Hide the div
    } else {
      divToHide.style.display = "none"; // Show the div
    }
  }
  // Add click event listener
  divToHide.addEventListener("click", () => {
    subscribeSaveDiv.classList.toggle("hidden");
  });

  // Attach change event listeners to radio inputs
  subscribeInput.addEventListener("change", toggleDivVisibility);
  oneTimeInput.addEventListener("change", toggleDivVisibility);

  // Trigger the function on page load to set the initial state
  toggleDivVisibility();
});
